import { Badge } from 'react-bootstrap';
import type { ProductData } from '../models/types';

interface MatchingCounterProps {
  readonly products: ProductData[];
  readonly selectedProducts: Record<string, Record<string, string>>;
}

export const MatchingCounter = ({ products, selectedProducts }: MatchingCounterProps) => {
  const getSelectedProductsCount = (): number => {
    return Object.keys(selectedProducts).length;
  };

  const getTotalProductsCount = (): number => {
    return products.length;
  };

  const selectedCount = getSelectedProductsCount();
  const totalCount = getTotalProductsCount();

  return (
    <Badge bg="secondary" style={{ fontSize: '0.8rem' }}>
      {selectedCount}/{totalCount}
    </Badge>
  );
};
